module.exports = __webpack_public_path__ + "img/PTTSymmetryOscura02.7611c6a6.jpg";